import {Utils, UtilsType} from "../utils/index.mjs";
import {Cell} from "@mecatran-components/table";
import * as patternizers from "./patternizer.mjs";

export var Constants = {  // #COMMENT To remove (replace by static values in direction )
	DIR_OUTBOUND :'1',
	DIR_INBOUND : '0'
}



export class ScheduleModelInterface{
	clone(){
		return new (this.clazz)(this);
	}
	log(){}
}



export class DestinationIndex extends ScheduleModelInterface{
    constructor(){
		super();
		var _items;
		
		Object.defineProperty(this,'clazz',{
			get : function(){
				return DestinationIndex;
			},
			enumerable : false
		});

        Object.defineProperty(this,'items',{
            set : function(i){
                if (!(i instanceof Array)) throw new Error('Index:item should be an array');
                _items = i;
            },
            get : function(){
                return _items
            },
            enumerable : true 
        });
	}
	copyPropFileToDestination(){  // TMP. this is a hack (instead provide a dataAdapter to a dataSource to perform this transform)
		this.items.forEach(item =>{
			Object.defineProperty(item.destination,'file',{
				get : function(){
					return item.file;
				},
				enumerable : true 
			});
		});
	}
	log(){
		var ret = {};
		// ret.items = this.items.map(destination => destination.log() )
		ret.items = this.items.map((destination, index) => { 
			var ret = {}; 
			ret[index] = destination.log();
			return ret;
		});
		return ret;
	}
	getDestinations(){
		return this.items;
	}
	getDestinationStations(){
		return this.items.map(item => item.getSchoolStation() );
	}
	getSchoolStations(){ return this.getDestinationStations() }
	getDestination(arg){  // destId or Destination
		var destId; 
		if (Utils.isString(arg)) destId = arg;
		else // arg != null && typeof arg === 'object' // object
			destId = arg.getId();

		var destination;
		this.items.some((item)=>{
			if (item.destination.getId() === destId){
				destination = item;
				return;
			}
		}); 
		return destination;
	}


	/* added 17-05 */
	findItemBySchoolId(schoolId){ 
		return (item)=>(item.getSchoolStation().getId() === schoolId)
	} 

	/* added 17-05 */
	getSchoolStation(destIdOrSchool){ return this.getDestination(destIdOrSchool) }
	
	/* added 17-05 */
	getFileName(schoolId){
		var destination = this.items.find(this.findItemBySchoolId(schoolId));
		if (destination) return destination.getFile();
		return;
	}

}

export class Destination extends ScheduleModelInterface{  //only for the index
	constructor(){
		super();
		var  _setId, _generatedAt, _version, _file, _destination;
		
		Object.defineProperty(this,'clazz',{
			get : function(){
				return Destination;
			},
			enumerable : false
		});
		
		Object.defineProperty(this,'setId',{
			set : function(v){
				_setId = v;
			},
			get : function(){
				return _setId;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'generatedAt',{
			set : function(v){
				_generatedAt = v;
			},
			get : function(){
				return _generatedAt;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'version',{
			set : function(v){
				_version = v;
			},
			get : function(){
				return _version;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'file',{
			set : function(v){
				_file = v;
			},
			get : function(){
				return _file;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'destination',{
			set : function(v){
				_destination = v;
				_destination.isDestination = true;  // TMP
			},
			get : function(){
				return _destination;
			},
			enumerable : true
		});
		
	}
	getSchoolStation(){ return this.destination }
	getFile(){ return this.file  };
	getIndex(){ return this.getFile() }
	log(){
		var ret = {};
		ret.setId = `${this.setId}`;
		ret.destination = this.destination.log.call(this.destination);
		return ret;
	}
}


export class ItineraryIndex extends ScheduleModelInterface{
	constructor(){
		super();
		var  _setId, _generatedAt, _version, _file, _destination, _stops, _routes, _itineraries;
		
		Object.defineProperty(this,'clazz',{
			get : function(){
				return ItineraryIndex;
			},
			enumerable : false
		});

		Object.defineProperty(this,'setId',{
			set : function(v){
				_setId = v;
			},
			get : function(){
				return _setId;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'generatedAt',{
			set : function(v){
				_generatedAt = v;
			},
			get : function(){
				return _generatedAt;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'version',{
			set : function(v){
				_version = v;
			},
			get : function(){
				return _version;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'file',{
			set : function(v){
				_file = v;
			},
			get : function(){
				return _file;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'destination',{
			set : function(v){
				_destination = v;
				_destination.isDestination = true;  // TMP
			},
			get : function(){
				return _destination;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'stops',{
			set : function(v){
				_stops = v;
			},
			get : function(){
				return _stops;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'routes',{
			set : function(v){
				_routes = v;
			},
			get : function(){
				return _routes;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'itineraries',{
			set : function(v){
				_itineraries = v;
			},
			get : function(){
				return _itineraries;
			},
			enumerable : true
		});	
	}
	log(logOptions){
		var ret = {};
		ret.setId = this.setId;
		ret.destination = this.destination.log(logOptions);
		ret.stops = this.stops.map(stop => stop.log(logOptions) );
		ret.routes = this.routes.map(route => route.log(logOptions));
		ret.itineraries = this.itineraries.map(itinerary => itinerary.log(logOptions));
		return ret;
	}

	getSetId(){ return this.setId }
	getVersion(){ return this.version }
	getItineraries(){
		return this.itineraries;
	}
	getNumberOfItineraries(){ return this.itineraries.length } 
	stripStops(stops){
		this.itineraries.forEach(itinerary => itinerary.stripStops(stops));
	}
	getStop(stopId){
        var retStop;
        this.stops.some(function(st){
			var found = (st.getId() === stopId );
			if (found) {retStop = st };
            return found; 
		});
		return retStop; 
	}
	getStations(){
		return this.stops.filter(stop => stop.checkIsStation());
	}
	getHomeStations(){
		return this.getStations();
	}

	/* added 17-05 */
	findHomeStationById(homeStationId){  return (homeStation)=>(homeStation.getId() === homeStationId )   }

	/* added 17-05 */
	getHomeStation(homeStationId){
		return this.getHomeStations().find(this.findHomeStationById(homeStationId))
	}

	getDestination(){
		return this.destination; 
	}
}



export class Route extends ScheduleModelInterface{
	constructor(){
		super();
		var  _id, _agencyId, _shortName, _longName, _type, _color, _textColor;
		
		Object.defineProperty(this,'clazz',{
			get : function(){
				return Route;
			},
			enumerable : false
		});
		
		Object.defineProperty(this,'id',{
			set : function(v){
				_id = v;
			},
			get : function(){
				return _id;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'agencyId',{
			set : function(v){
				_agencyId = v;
			},
			get : function(){
				return _agencyId;
			},
			enumerable : true
		});

		Object.defineProperty(this,'shortName',{
			set : function(v){
				_shortName = v;
			},
			get : function(){
				return _shortName;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'longName',{
			set : function(v){
				_longName = v;
			},
			get : function(){
				return _longName;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'type',{
			set : function(v){
				_type = v;
			},
			get : function(){
				return _type;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'color',{
			set : function(v){
				_color = v;
			},
			get : function(){
				return _color;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'textColor',{
			set : function(v){
				_textColor = v;
			},
			get : function(){
				return _textColor;
			},
			enumerable : true
		});
		
	}
	log(){
		var ret = {};
		ret.shortName = this.shortName;
		return ret;
	}
}

export class Stop extends ScheduleModelInterface{
	constructor(){
		super();
		var  _isstation= false,
			 _id, _code, _name, _description, _city, _city2,
			_stopIds = [], 
			_agencyIds = [],
			_isDestination = false, _lat, _lon, 
			_itineraries = [],
			_erpDest = false, 
			_erpHome = false 
		;
		
		Object.defineProperty(this,'clazz',{
			get : function(){
				return Stop;
			},
			enumerable : false
		});
		
		Object.defineProperty(this,'isStation',{
			set : function(v){
				_isstation = v;
			},
			get : function(){
				return _isstation;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'id',{
			set : function(v){
				_id = v;
			},
			get : function(){
				return _id;
			},
			enumerable : true
		});

		Object.defineProperty(this,'code',{
			set : function(v){
				_code = v;
			},
			get : function(){
				return _code;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'name',{
			set : function(v){
				_name = v;
			},
			get : function(){
				return _name;
			},
			enumerable : true
		});

		Object.defineProperty(this,'description',{
			set : function(v){
				_description = v;
			},
			get : function(){
				return _description;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'city',{
			set : function(v){
				_city = v;
			},
			get : function(){
				return _city;
			},
			enumerable : true
		});

		Object.defineProperty(this,'city2',{
			set : function(v){
				_city2 = v;
			},
			get : function(){
				return _city2;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'stopIds',{
			set : function(v){
				_stopIds = v;
			},
			get : function(){
				return _stopIds;
			},
			enumerable : true
		});

		Object.defineProperty(this,'agencyIds',{
			set : function(v){
				_agencyIds = v;
			},
			get : function(){
				return _agencyIds;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'isDestination',{
			set : function(v){
				_isDestination = v;
			},
			get : function(){
				return _isDestination;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'lat',{
			set : function(v){
				_lat = v;
			},
			get : function(){
				return _lat;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'lon',{
			set : function(v){
				_lon = v;
			},
			get : function(){
				return _lon;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'itineraries',{
			set : function(v){
				// if (Utils.checkIsArray() throw new Error()  // ### [clone]
				// _itineraries = new Array();
				_itineraries = v; // !! ### [clone]
				
			},
			get : function(){
				return _itineraries;
			},
			enumerable : true
		});	

		Object.defineProperty(this,'erpDest',{
			set : function(v){ _erpDest = v },
			get : function(){ return _erpDest },
			enumerable : true 
		});

		Object.defineProperty(this,'erpHome',{
			set : function(v){ _erpHome = v },
			get : function(){ return _erpHome },
			enumerable : true 
		});


	}
	log(){
		var ret = {};
		ret.name = `(${this.id}) ${this.name} (isStation: ${this.isStation} # nItinerararies:${this.itineraries.length} # nSubStops: ${this.stopIds.length})`;
		return ret;
	}
	logTable(logOptions = {mapOnKey : 'id'}){
		var retVal = {};
		retVal.id = this.getId();
		retVal.code = this.getCode(); 
		retVal.name = this.getName();
		retVal.city = this.getCity();
		retVal.isStation = this.getIsStation(); 
		retVal.nIti = this.getNumberItineraries();
		retVal.erpHome = this.getIsErpHome();
		retVal.erpDest = this.getIsErpDest();
		retVal.nSubStops = this.getNumberSubStops();
		var identifier = this[logOptions.mapOnKey]; // this[code]
		var ret = {};
		ret[identifier] = retVal;
		return ret;
	}
	checkIsStation(){
		return this.isStation;
	}
	getId(){ return this.id; }
	getCode(){ return this.code }
	getName(){return this.name }
	getCity(sec=true){ 
		var city = this.city;
		var city2 = this.getCity2();
		if (sec && UtilsType.isDef(city2) ) city = `${city} (${this.getCity2()})`
		return  city;
	}
	getCity2(){ return this.city2 }

	getFullName(){
		var str;
		var name = this.getName();
		var city = this.getCity(true);
		str = `${name} ${city}`;
		return str;
	}

	getIsStation(){ return this.isStation || 0 }
	getIsDestination(){ return this.isDestination }  //this.isDestination prop is added later
	getIsSchool(){ return this.getIsDestination() }
	getDescription(){ return this.description }
	getLatLon(){ return [this.lat, this.lon]}
	getNumberItineraries(){
		if (!this.getIsStation()) return this.itineraries.length;
		var numberItineraries;
		var reducer = (accumulator,n)=> accumulator + n;
		if (this.getNumberSubStops()) numberItineraries = this.getSubStops().map(stop => stop.getNumberItineraries()).reduce(reducer);
		else numberItineraries = 0;
		return numberItineraries;
	}
	getItineraries(bool=true){ 
		if (this.itineraries && this.itineraries.length) return this.itineraries;
		if (bool){
			var itineraries = [];
			this.getSubStops().forEach(substop =>{
				itineraries = [...itineraries, ...substop.getItineraries()];
			});
			return itineraries;
		}
	}
	getIsErpHome(){ return this.erpHome }
	getIsErpDest(){ return this.erpDest }
	getSubStops(){ return this.stopIds; }  // ## this.stopIds returns the subStops not the stopIds (change serializer)
	getNumberSubStops(){ return this.stopIds.length }
	getAgencyIds(){ return this.agencyIds }
	getHashKey(){
		return `${this.id}`; 
	}
	getHashCode(...keys){
		var isKey = (key)=> (key in this);
		if (keys.length && keys.every(isKey)) return Utils.combineHashCodes(...keys);
		return Utils.hashCode(this.getId())
	}	
}

export class Itinerary extends ScheduleModelInterface{
	constructor(itinerary){
		super();
		var  _id = (itinerary) ? itinerary.id : undefined, 
			_direction = 'x',
			_calendar = (itinerary) ? itinerary.calendar.clone() : undefined, 
			_trips = (itinerary) ? itinerary.trips.map(trip => trip.clone())  : [],
			_cloneCounter = 0
		;
		
		Object.defineProperty(this,'clazz',{
			get : function(){
				return Itinerary;
			},
			enumerable : false
		});
		
		Object.defineProperty(this,'id',{
			set : function(v){
				_id = v;
			},
			get : function(){
				return _id;
			},
			enumerable : true
		});

		Object.defineProperty(this,'direction',{
			set : function(v){
				_direction = v;
			},
			get : function(){
				return _direction;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'calendar',{
			set : function(v){
				_calendar = v;
			},
			get : function(){
				return _calendar;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'trips',{
			set : function(v){
				_trips = v;
			},
			get : function(){
				return _trips;
			},
			enumerable : true
		});	

		Object.defineProperty(this,'incrementCloneCounter',{
			value : function(){
				_cloneCounter++;
			},
			enumerable : false
		});	

		Object.defineProperty(this,'getCloneCounter',{
			value : function(){
				return _cloneCounter;
			},
			enumerable : false
		});	

		this[Symbol.iterator] = this.stopTimeGenerator;

	}
	clone(){   // ##COMMNT DEPRECATED
		var iti = new Itinerary(this);
		this.incrementCloneCounter();
		iti.setId(`${this.getId()}(c${this.getCloneCounter()})`);
		return iti;
	}

	getConstructorDirection(){ return Direction }

	getConstructor(){ return Itinerary }

	setId(id){ this.id = id; }

	getId(){ return this.id }

	getTrips(all = false){   
		var trips = [];
		var iterator = (all) ? this.getAllTripsIterator() : this.getVisibleTripsIterator();
		for (var trip of iterator){
			trips.push(trip);
		}
		return trips;
	}

	getDirection(asName = true, consolidated = false ){
		var trips = this.getTrips();
		var directions = trips.map(trip => trip.getDirection(asName));
		if (consolidated){
			var refDir = trips[0].getDirection(asName);
			var hasSameDirection = function(element){ return (element === refDir) }     // #COMMENT compare ok
			if (directions.every(hasSameDirection)) return refDir; 
			else return '??';
		}
		return trips.map(trip => trip.getDirection(asName))
	}

	getRanges(){
		return this.calendar.ranges;
	}

	getRangesFrom(){
		return this.calendar.ranges.map(range => range.from );
	}

	getFirstDateRangeFrom(){
		return new Date(this.getRangesFrom()[0]);
	}

	getRangesTo(){
		return this.calendar.ranges.map(range => range.to );
	}

	getLastDateRangeTo(){
		var rangesTo = this.getRangesTo();
		return new Date(rangesTo[rangesTo.length - 1]);
	}

	getDowHashKey(){     // #COMMENT should be Hashkey 
		return this.calendar.getDowHashKey();
	}

	getDows(){
		return this.calendar.getDows();
	}
	getDowStr(summary){  // should use translate
		var daysOfWeek ; 
		if (summary ) daysOfWeek = ['L','M','me','J','V','S','D','JF'];
		else daysOfWeek = ['Lundi','Mardi','Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche','Jours Fériés']
		return Utils.dowToArray(daysOfWeek, this.getDows())
	}

	getPatternHashKey(){
		var hashKey = '';
		var trips = this.getTrips();
		var indexLast = trips.length-1;
		trips.forEach((trip,index) => {
			hashKey = `${hashKey}${trip.getPatternHashKey()}`;
			if (index !== indexLast) hashKey += '#';
		});
		return hashKey;
	}

	// other getters
	// -------------
	getFirstStopTime(){ 
		var trips = this.getTrips();
		return trips[0].getFirstStopTime(); 
		
	}

	// tests
	// -----
	/**
	 * @param pattern 
	 * @param directionName 
	 * @return the result (as bool) of the test of match between the @param:directionName and the computedDirection from the pattern
	 */
	static testPatternDirection(pattern, directionName){
		var patternizer;
		if (directionName === Direction.inbound  ) patternizer = patternizers.directionHSPattern;
		if (directionName === Direction.outbound ) patternizer = patternizers.directionSHPattern;
		var services = patternizer.getServices(pattern);
		return services.test();
	}

	// loggers
	// -------
	log(options = {displayDetails: false, displayDirAsName: true ,  includePatterns:false,homeStation : undefined,schoolStation : undefined,dir:undefined}){
		var ret = {};
		var tripNames = [];
		var trips = this.getTrips();
		trips.forEach(trip => {
			tripNames.push(trip.getTripName());
		});
		var strTripNames = tripNames.join('#');
		ret.trips = `${strTripNames}`;
		ret.id = `${this.getId()}`;
		if (options.displayDetails){
			ret.trips = trips.map(trip => trip.log());	
		} 
		ret.direction = this.getDirection(options.displayDirAsName, options.consolidatedDir);
		if (options.includePatterns){
			var str = ''
            if (options.includePatterns) {
				str += `[${this.getPatternHomeSchool(options.homeStation,options.schoolStation)}]`;
				// str += `(${this.getDirection(options.displayDirAsName)})`;
				/*
                // str += `(${iti.getDirection() ===0 ?'IN':'OUT'})`;
				str += `(${this.getTripsDirection()}`;
				str += `\\
				${this.getDirectionFromHSPattern(options.stopsA,options.stopsB)})`   // getComputedDirection
				*/
            }
			str += '';
			ret.pattern = str;
		}
		if (options.includeDropoffPattern){  // what about other dropoff types ?
			str = '';
			str += `[${this.getDropoffPattern(1)}]`;
			ret.dropoffPattern = str;
		}
		if (options.includePickupPattern){
			str = '';
			str += `[${this.getPickupPattern(1)}]`; // what about other pickup types ?
			ret.pickupPattern = str;			
		}
		if (options.includeDateFrom){
			str = '';
			str += `${this.getRangesFrom()}`;
			ret.dateFrom = str;
		}
		if (options.includeDateTo){
			str = '';
			str += `${this.getRangesTo()}`;
			ret.dateTo = str;
		}
		return ret; 
	}

	logTable(options = {mapOnKey: 'id',displayDetails: false, displayDirAsName: true, includePatterns:false,homeStation,schoolStation,consolidatedDir:true}){

		var identifier; 
		switch(options.mapOnKey){
			case 'id':
				identifier = this.getId();
				break;
			default:
				identifier = this.getId();
		}

		var ret = {};
		ret[identifier] = this.log(options);;
		return ret;
	}


	// iterators 
	// ---------
/**
 * 
 * @param tripIndex (optional)
 */
	*stopTimeGenerator(tripIndex){
		var trips = this.getTrips(true); // all trips, not only visible
		if (tripIndex && (tripIndex < trips.length)) trips = [trips[tripIndex]];
		for (var trip of trips){   
			var stopTimeIterator = trip.getStopTimeIterator();
			var n;
			while((!(n = stopTimeIterator.next()).done)){ yield n.value   }
		} 
	}

	getStopTimeIterator(tripIndex){ return this.stopTimeGenerator(tripIndex) }

	*getAllTripsGenerator(){
		var trips = this.trips;
		for (var trip of trips){ yield trip}
	}

	getAllTripsIterator(){ return this.getAllTripsGenerator() }

	*getVisibleTripsGenerator(){
		var trips = this.trips;
		for (var trip of trips){
			if (!trip.isHidden()) yield trip;
		}
	}

	getVisibleTripsIterator(){ return this.getVisibleTripsGenerator() }

	// sequences
	// =========

	getStopTimeSequence(){    //## COMMENT static ?
		var iterator = this.getStopTimeIterator();
		var n;
		var stopTimeSequence = [];
		while((!(n=iterator.next()).done)){
			stopTimeSequence.push(n.value);
		}
		return stopTimeSequence;
	}

/**
 * Translates pattern Indexes into stopTimes Indexes
 * @param pIndexes pattern indexes
 * ex: 
 * pattern '**H*#***S**' --> pIndexes [0,1,2,3,4,5,6] <---> stopTimesIndexes [0,1,2,3,4,5]
 * pattern '**H*#**#**S*' --> pIndexes [0,11] <--> stopTimeIndexes [0,1,2,3,4,5,6,7,8,9]
 * pattern '**H*#**#S***' --> pIndexes [2,3,4,5,6,7,8] <--> stopTimeIndexes [2,3,4,5,6]
 * pattern 'H*#****#*S**' --> pIndexes [0,1,2,3,  6,7,8,9] <--> stopTimesIndexes [0,1,2,   5,6,7]
 */
	static getStopTimeIndexes(pIndexes, pattern ){
		var charSet = new Set(Object.values(Trip.chars));

		var tIndexes = []; // indexes of trips  

		// 1. get the tIndexes  [where the '#' are]
		for (var i=0; i< pattern.length; i++){
			if (!charSet.has(pattern[i])) tIndexes.push(i)
		}
		var stIndexes = [];
		var tripCount = 0, nextTripIndex = tIndexes[tripCount];
		for (var i =0 ; i < pIndexes.length; i++){
			if (pIndexes[i] === nextTripIndex) continue;
			if (pIndexes[i]> nextTripIndex){
				nextTripIndex = tIndexes[++tripCount];
			}
			
			stIndexes.push(pIndexes[i] - tripCount);
		}
		return stIndexes;
	}

/**
 * 
 * @param pattern - pattern (including possibly '#' ) for which the indexes refer to Ex: '***H*#**S**#*'
 * @param pIndexes - indexes of elements of the pattern (ex: [3,8])
 * @param ref - if ref = false, the function returns the stopTimes that are not refered by the pattern
 * Description: this function returns the stopTimes that are referred by the pattern 
 */
	getStopTimeSequenceFrom(pIndexes, pattern, ref = true){   //## COMMENT static  function ?
		var pIndexes = pIndexes, indexesSet = new Set(pIndexes);
		if (!ref) pIndexes = pattern.split('').map((el,i)=>i).filter(i => (!indexesSet.has(i) ));  // not contained 
		console.log('pIndexes:',pIndexes);
		var stopTimeSequence = this.getStopTimeSequence();
		var stopTimeIndexes = Itinerary.getStopTimeIndexes(pIndexes, pattern );

		var stopTimeSubSeq = [];
		for (var ind of stopTimeIndexes){
			stopTimeSubSeq.push(stopTimeSequence[ind])
		}
		return stopTimeSubSeq;
	}






	// state modifiers
	// ---------------
/**
 * Keep The stoptimes that are refered by the combination indexes/pattern
 * @param indexes 
 * @param pattern 
 */
	showStopTimes(indexes, pattern ){
		var stopTimes = this.getStopTimeSequenceFrom(indexes, pattern, false )
		stopTimes.forEach(stopTime => stopTime.hide());
		this.hideTrips();
	}

	hideStopTimes(indexes, pattern){
		var stopTimes = this.getStopTimeSequenceFrom(indexes, pattern, true )
		stopTimes.forEach(stopTime => stopTime.hide());
		this.hideTrips();
	}

	hideTrips(){  // hide empty trips Only
		for (var trip of this.getAllTripsIterator()){
			if (trip.isEmpty()) trip.hide();
		}
	}

	reset(){
		this.getTrips(true).forEach(trip => trip.show());
		this.getTrips().forEach(trip => trip.reset());
	}

	setSummarizedPattern(homeStation,schoolStation){ 
		//var params0 = [ homeStation,schoolStation,{ joinChar : '', joinTrip : ''}];
		var params = [ homeStation,schoolStation,{ joinChar : '', joinTrip : '#'}]
		var pattern = this.getPatternHomeSchool(...params);
		var summaryPatternizer = patternizers.summaryPattern;
		var indexes =  summaryPatternizer.getServices(pattern).getIndexes();
		this.showStopTimes(indexes, pattern);

		// direct H>S
		/*
		var pattern = this.getPatternHomeSchool(...params); 
		console.log('-------------->',pattern)
		var directHSPatternizerService = patternizers.directHSPatternBis.getServices(pattern);
		var test = directHSPatternizerService.test();
		if (test){
			var indexes = directHSPatternizerService.getIndexes();
			this.showStopTimes(indexes,pattern);
		}
		*/
		
		return this.getPatternHomeSchool(...params); 
	}

	setDirectPattern(homeStation, schoolStation){
		var asName = true, consoDir = true;
		var directionName = this.getDirection(asName, consoDir);
		var params = [ homeStation,schoolStation,{ joinChar : '', joinTrip : '#'}]
		var pattern = this.getPatternHomeSchool(...params);
		var patternizer;
		if (directionName === Direction.inbound  ) patternizer = patternizers.directHSPatternBis;
		if (directionName === Direction.outbound ) patternizer = patternizers.directSHPatternBis;	
		var services = patternizer.getServices(pattern);
		var indexes = services.getIndexes();	
		if (indexes.length)  this.showStopTimes(indexes, pattern);
	}


	// translators 
	// -----------
/**
 * 
 * @param homeStation 
 * @param schoolStation 
 * @param options   
 * 	- displayAllStops // (displayAllNonHiddenStops) if false or not set will display only stops and schools, if set will display all the non hidden stops 
 */
	toTable(homeStation,schoolStation, options, cutoffDate  ){   // ## not necessary to redeclare var header and var data at each use 
		var displayAllStops = (UtilsType.isDef(options) && UtilsType.isDef(options.displayAllStops)) ? options.displayAllStops : false;
		/*
		var homeIdSet = new Set(homeStation.getSubStops().map(stop=>stop.getId()));   // use testIsHomeStop 
		var schoolIdSet = new Set(schoolStation.getSubStops().map(stop=>stop.getId()));

		var testIsHomeStop = (stop) => homeIdSet.has(stop.getId());  // NOT USED replace by this.testIsHomeStop
		var testIsSchoolStop = (stop) => schoolIdSet.has(stop.getId());
		*/
		var testIsHomeStop = this.testIsHomeStop(homeStation);
		var testIsSchoolStop = this.testIsSchoolStop(schoolStation);

		var trips = this.getTrips();
		var cellHeader, cellData;

		var header = [];
		var data = [];
		var dataColumn = [];

		var firstTrip = trips[0],
			lastTrip = trips[trips.length - 1]
		;

		// add  itinerary-id
		var cellHeader = new Cell(); 
		cellHeader.addClass('itinerary-id');
		header.push(cellHeader);
		var cellData = new Cell(); 
		cellData.addContent(this.getId()); cellData.addClass('itinerary-id')
		dataColumn.push(cellData);

	
		// add date 
		var fromClass, toClass, fromContent = "", toContent = "";
		var dateOptions = {weekday: "short", year: "numeric", month: "short", day: "numeric"};
		var firstDate = this.getFirstDateRangeFrom();
		var lastDate = this.getLastDateRangeTo();
		var currentDate = new Date();
		if (Utils.diffDays(firstDate, currentDate) > 0) {
			fromClass = "from"; 
			fromContent = `A partir du ${firstDate.toLocaleDateString('fr-Fr', dateOptions)}` ;// translations
		} 
		if (Utils.diffDays(lastDate, cutoffDate ) < -6 ){
			toClass = "to";
			toContent = `Jusqu'au ${lastDate.toLocaleDateString('fr-Fr', dateOptions)}` ;
		} 
		if (fromContent || toContent){
			var cellHeader = new Cell();
			cellHeader.addClass('range');
			header.push(cellHeader);
			var cellData = new Cell();
			cellData.addContent(fromContent, fromClass); 
			cellData.addContent(toContent, toClass);
			cellData.addClass('range');
			dataColumn.push(cellData);
		}


		// add dow 
		var cellHeader = new Cell(); 
		cellHeader.addClass('dow');
		header.push(cellHeader);
		var cellData = new Cell(); 
		cellData.addContent(this.getDowStr(true),'tooltip'); 
		cellData.addContent(this.getDowStr(false),'tooltip-text');
		cellData.addClass('dow');
		dataColumn.push(cellData);

		for (var trip of trips){

			var stopTimeSequence = trip.getStopTimeSequence();
			var length = stopTimeSequence.length;
			var lastStopTime = stopTimeSequence[length -1];
			var firstStopTime = stopTimeSequence[0];

			var hasLibelle = trip.hasLibelle();
			var hasPhone = trip.hasPhone();
			var hasEmail = trip.hasEmail();
			var hasTripName = trip.hasTripName();

			// add tripname 
			var cellHeader = new Cell(); 
			header.push(cellHeader); 
			var cellData = new Cell();
			cellData.addContent(trip.getTripName())
			cellData.addClass('tripname');
			dataColumn.push(cellData);	

			var cellHeader = new Cell(); 
			cellHeader.addClass('info');
			header.push(cellHeader); 
			
			var cellData = new Cell();
			cellData.addClass('info');
			if (hasLibelle) cellData.addContent(trip.getLibelle(),'libelle');
			if (hasPhone) cellData.addContent(trip.getPhone(),'phone');
			//if (hasEmail) cellData.addContent(trip.getEmail(),'email');	
			if (hasEmail){
				var email = trip.getEmail();
				email = Utils.replaceEmail(email);
				cellData.addContent(email,'email');
			}
			//if (!hasLibelle && !hasPhone && !hasEmail) 
			dataColumn.push(cellData);				
	

			for (var stopTime of stopTimeSequence){
				var isHomeStop = testIsHomeStop(stopTime.getStop());
				var isSchoolStop = testIsSchoolStop(stopTime.getStop());
				var displayStop = displayAllStops || (isHomeStop || isSchoolStop);
				var condHubLast = ((stopTime === lastStopTime) && ( trip !== lastTrip)) ;
				var condHubFirst = ((stopTime === firstStopTime) && (trip !== firstTrip))
				var stop = stopTime.getStop();
				var description = stop.getDescription(); // add check description in parent 
				var directionName = trip.getDirection(true); // direction as name 

				//if (description )debugger;

				// add description 
				if ((trip === firstTrip) && (stopTime === firstStopTime) && (description) && (directionName === Direction.outbound)){
					var cellHeader = new Cell({content:'correspondance'}); cellHeader.addClass('transfer');  // TMP translate "transfer"
					header.push(cellHeader);
					var cellData = new Cell({content: description});  cellData.addClass('transfer-description');
					dataColumn.push(cellData);
				}

	
					
				if (displayStop){
					var cellHeader = new Cell(); 
					cellHeader.addContent(stopTime.getStop().getName(), 'stopname')
					var cityName = stopTime.getStop().getCity(true);
					if (cityName) cellHeader.addContent(stopTime.getStop().getCity(true), 'cityname')
					cellHeader.addClass('stopheader'); 
					if (isHomeStop) cellHeader.addClass('home'); 
					if (isSchoolStop) cellHeader.addClass('school');
					header.push(cellHeader);
					var cellData = new Cell(); cellData.addClass('departure');
					cellData.addContent(stopTime.getDeparture());
					if (isHomeStop) cellData.addClass('home'); 
					if (isSchoolStop) cellData.addClass('school');
					dataColumn.push(cellData);					
				} 
			
				

				if ((stopTime === lastStopTime) && ( trip !== lastTrip)){
					/*
					var cellHeader = new Cell('transfer'); cellHeader.addClass('transfer');
					header.push(cellHeader);
					var cellData = new Cell(stopTime.getStop().getName(),'stopName'); 
					cellData.addContent(stopTime.getStop().getCity(true),'cityName');
					cellData.addClass('transfer-description')
					dataColumn.push(cellData);	
					*/						
					//var cellHeader = new Cell(stopTime.getStop().getName(),'stopName'); 
					var cellHeader = new Cell({content:'correspondance'});   // TMP translate "transfer"
					cellHeader.addContent(stopTime.getStop().getName(),'stopName')
					var cityName = stopTime.getStop().getCity(true);
					if (cityName) cellHeader.addContent(stopTime.getStop().getCity(true),'cityName');
					cellHeader.addClass('transfer-description');
					cellHeader.addClass('transfer'); // TMP useful to merge 
					header.push(cellHeader);
					var cellData = new Cell();
					cellData.addClass('transfer-description')
					dataColumn.push(cellData);			
				}

				if ((trip === lastTrip) && (stopTime === lastStopTime) && (description) && (directionName === Direction.inbound)){
					var cellHeader = new Cell({content: 'correspondance'}); cellHeader.addClass('transfer');   // TMP translate "transfer"
					header.push(cellHeader);
					var cellData = new Cell(description);  cellData.addClass('transfer-description');
					dataColumn.push(cellData);
				}
			}

		}

		return { header, dataColumn };	

		var table = new Table();
		var data = [dataColumn];
		table.setDataByColumn(data,header);
		return table;	

	}
	


	// Utils
	// -----
/**
 * @param options { joinChar, joinTrip }  
 * 	- joinChar : join betweens the characters of the pattern 
 * 	- joinTrip : join between the trips  
 */

	getPatternHomeSchool(homeStation,schoolStation, options = { joinChar : ''}){	
		var joinChar = (options && ('joinChar' in options)) ? options.joinChar : ''; 
		var joinTrip = UtilsType.isDef(options.joinTrip) ? options.joinTrip : '#';
		var firstChar = '';
		var str = firstChar;
		var trips = this.getTrips();
		//var firstIndex = (trips[0]);
		var firstNonEmptyTrip = true;
		var n;
		trips.forEach((trip,index) => {
			var tripPattern = trip.getPatternHomeSchool(homeStation,schoolStation, joinChar);
			if (tripPattern){ 
				str += ((!firstNonEmptyTrip) && (joinTrip)) ? joinTrip:  '';
				firstNonEmptyTrip = false;
				str += tripPattern;
			}
		
		});
		if (str === firstChar) str = '(---)' 
		return str;
	}

	getDropoffPattern(type){
		var str = '';
		var stopTimeSequence = this.getStopTimeSequence();
		for (var stopTime of stopTimeSequence){
			if (stopTime.hasDropoffType(type)) str += '1';
			else str += '0'
		}
		return str;
	}

	getPickupPattern(type){
		var str = '';
		var stopTimeSequence = this.getStopTimeSequence();
		for (var stopTime of stopTimeSequence){
			if (stopTime.hasPickupType(type)) str += '1';
			else str += '0'
		}
		return str;
	}

	// =================
	// tests & filters 
	// -----------------

/*
	var homeIdSet = new Set(homeStation.getSubStops().map(stop=>stop.getId()));   // use testIsHomeStop 
	var schoolIdSet = new Set(schoolStation.getSubStops().map(stop=>stop.getId()));

	var testIsHomeStop = (stop) => homeIdSet.has(stop.getId());  // NOT USED replace by this.testIsHomeStop
	var testIsSchoolStop = (stop) => schoolIdSet.has(stop.getId());
*/



	testIsHomeStop(homeStation){
		var homeStops = (homeStation) ? (homeStation.getSubStops()) : [];
		var homeStopSet = new Set(homeStops);
		return (stop)=>homeStopSet.has(stop);
		
	}

	testIsSchoolStop(schoolStation){
		var schoolStops = (schoolStation) ? (schoolStation.getSubStops()) : [];
		var schoolStopSet = new Set(schoolStops);
		return (stop)=>schoolStopSet.has(stop);
	}

	testIsHomeStop2(homeStation){
		var homeStops = (homeStation) ? (homeStation.getSubStops()) : [];
		var homeIdSet = new Set(homeStops.map(stop=>stop.getId()));   // use testIsHomeStop 
		return (stop) => homeIdSet.has(stop.getId()); 
	}

	testIsSchoolStop2(schoolStation){
		var schoolStops = (schoolStation) ? (schoolStation.getSubStops()) : [];
		var schoolIdSet = new Set(schoolStops.map(stop=>stop.getId()));
		(stop) => schoolIdSet.has(stop.getId());
	}

};

export class Calendar extends ScheduleModelInterface{
	constructor(calendar){
		super();
		var _ranges = (calendar) ? calendar.ranges.map(range => range.clone()) : [], 
			_dows = (calendar) ? calendar.dows.slice() : [], 
			_negativeExceptions = (calendar) ? calendar.negativeExceptions.slice() : []
		;
		
		Object.defineProperty(this,'clazz',{
			get : function(){
				return Calendar;
			},
			enumerable : false
		});		

		Object.defineProperty(this,'ranges',{
			set : function(v){
				_ranges = v;
			},
			get : function(){
				return _ranges;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'dows',{
			set : function(v){
				_dows = v;
			},
			get : function(){
				return _dows;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'negativeExceptions',{
			set : function(v){
				_negativeExceptions = v;
			},
			get : function(){
				return _negativeExceptions;
			},
			enumerable : true
		});
	}
	log(){
		var ret = {};
		ret.ranges = this.ranges.map(range => range.log());
		var strDows = '[';
		var length = this.dows.length;
		this.dows.forEach((dow, index) =>{
			strDows += dow;
			if (index !== length-1) strDows += '|';
		}); 
		strDows += ']';
		ret.dows = strDows;
		ret.negativeExceptions = JSON.stringify(this.negativeExceptions);
		return ret; 
	}
	getDowHashKey(){
		return Utils.dowToHashKey(this.dows);
	}
	getDows(){ return this.dows }
	getRangeHashKey(){

	}
}

export class Range extends ScheduleModelInterface{
	constructor(range){
		super();
		var  _from = (range) ? range.from : '', 
			_to = (range) ? range.to : ''
		;

		Object.defineProperty(this,'clazz',{
			get : function(){
				return Range;
			},
			enumerable : false
		});
		
		Object.defineProperty(this,'from',{
			set : function(v){
				_from = v;
			},
			get : function(){
				return _from;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'to',{
			set : function(v){
				_to = v;
			},
			get : function(){
				return _to;
			},
			enumerable : true
		});
	}
	log(){
		return `[${this.from} - ${this.to}]`;
	}
}
/*
export class Dow{}
export class NegativeExceptions{}
*/

export class Direction extends ScheduleModelInterface{
	constructor(directionId){
		super();
		var _directionId = UtilsType.isNumber(directionId) ? directionId.toString() : directionId;

		Object.defineProperty(this,'directionId',{
			get : function(){ return _directionId },
			enumerable : true 
		});
	}
	equal(direction){ return (direction.directionId === this.directionId )}
	getDirectionId(){ return this.directionId }
	getDirectionName(){
		var map = new Map([['0','inb'],['1','outb']]);  //inbound towards school  // replace 'inb' by a static value 
		return map.get(this.directionId)
	}
	log(logOptions = { displayDirAsName : false }){
		var direction; 
		if (logOptions && logOptions.displayDirAsName) { // display direction Name or digit
			direction = this.getDirectionName();
		} else direction = this.directionId;
		return direction; 
	}
}
Direction.inbound = 'inb';
Direction.outbound = 'outb';

export class Trip extends ScheduleModelInterface{
	constructor(trip){
		super();
		var  _tripIds = (trip) ? trip.tripIds.slice() : [],  
			_routeId = (trip) ? trip.routeId : '', 
			_headsign = (trip) ? trip.headSign : '', 
			_tripName = (trip) ? trip.tripName : '-', 
			_blockId = (trip) ? trip.blockId : '', 
			_directionId = (trip) ? trip.directionId : '', 
			_extLibelle = (trip) ? trip.extLibelle : undefined,
			_extPhone = (trip) ? trip.extPhone : undefined,
			_extEmail = (trip) ? trip.extEmail : undefined,
			_times = (trip) ? trip.times.map(time=> time.clone()) : [],
			_hidden = false
		;
		

		Object.defineProperty(this,'clazz',{
			get : function(){
				return Trip;
			},
			enumerable : false
		});
		
		Object.defineProperty(this,'tripIds',{
			set : function(v){
				_tripIds = v;
			},
			get : function(){
				return _tripIds;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'routeId',{
			set : function(v){
				_routeId = v;
			},
			get : function(){
				return _routeId;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'headsign',{
			set : function(v){
				_headsign = v;
			},
			get : function(){
				return _headsign;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'tripName',{
			set : function(v){
				_tripName = v;
			},
			get : function(){
				return _tripName;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'blockId',{
			set : function(v){
				_blockId = v;
			},
			get : function(){
				return _blockId;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'directionId',{
			set : function(v){
				_directionId = v;
			},
			get : function(){
				return _directionId;
			},
			enumerable : true
		});

		Object.defineProperty(this,'extLibelle',{
			set : function(e){ _extLibelle = e },
			get : function(){ return _extLibelle },
			enumerable : true
		});

		Object.defineProperty(this,'extPhone',{
			set : function(p){ _extPhone = p },
			get : function(){ return _extPhone },
			enumerable : true
		});

		Object.defineProperty(this,'extEmail',{
			set : function(e){ _extEmail = e },
			get : function(){ return _extEmail },
			enumerable : true
		});

		Object.defineProperty(this,'hidden',{ // ## COMMENT actual property (contrary to "hide" which is an action/method )
			set : function(b){ _hidden = b },
			get : function(){ return _hidden }
		})
		
		Object.defineProperty(this,'times',{
			set : function(v){
				_times = v;
			},
			get : function(){
				return _times;
			},
			enumerable : true
		});

		this[Symbol.iterator] = this.stopTimeGenerator;
		
	}

	// getters
	// -------

	getDirection(asName = true ){
		if (asName) return this.directionId.getDirectionName();
		else return this.directionId.getDirectionId();
	}
	getTripName(){ return this.tripName }

	getLibelle(){ return this.extLibelle }
	getPhone(){ return this.extPhone }
	getEmail(){ return this.extEmail }
	

	// test
	//-----
	hasTripName(){ return UtilsType.isDef(this.tripName )}
	hasLibelle(){ return UtilsType.isDef(this.extLibelle) }
	hasPhone(){ return UtilsType.isDef(this.extPhone) }
	hasEmail(){ return UtilsType.isDef(this.extEmail )}
	isEmpty(){ 
		var stopTimeSequence = this.getStopTimeSequence();
		return (!stopTimeSequence.length);
	}
	isHidden(){ return this.hidden }


	// iterators 
	// ---------
	*stopTimeGenerator(){
		var stopTimes = this.times;
		for (var stopTime of stopTimes ){
			if (!stopTime.isHidden()) yield stopTime;
		}
	}

	getStopTimeIterator(){ return this.stopTimeGenerator();  }

	// sequences 
	// ---------
	getStopTimeSequence(){
		var n;
		var stopTimeSequence = [];
		for (var stopTime of this){
			stopTimeSequence.push(stopTime);
		}
		return stopTimeSequence;
	}

	getStopSequence(){
		return this.getStopTimeSequence().map(stopTime => stopTime.getStop())
	}

	// state modifiers 
	// ---------------
	reset(){
		this.times.forEach(stopTime => stopTime.show())
	}

	hide(){
		this.hidden = true;
	}
	show(){
		this.hidden = false; 
	}


	// other getters
	// -------------
	getPatternHashKey(){
		var str = '';
		var stopTimeSequence = this.getStopTimeSequence();
		var indexLast = stopTimeSequence.length -1;
		stopTimeSequence.forEach((time,index)=>{
			str = `${str}${time.getStop().getHashKey()}`;
			if (index !== indexLast) str += '|';			
		});
		return str;
	}

	getFirstStopTime(){
		var iterator = this.getStopTimeIterator();
		return iterator.next().value;
	}


	// utils
	// -----
	/*
	getPatternHomeSchool(homeStation,schoolStation, joinChar = '-'){
		//var joinChar = (joinChar === null )
		//var joinChar = joinChar || defaultJoinChar;
		var homeStops = (homeStation) ? homeStation.getSubStops() : [];
		var schoolStops = (schoolStation) ? schoolStation.getSubStops() : [];
		var setHome = new Set(homeStops);
		var setSchool = new Set(schoolStops);  // TODO: check common elements between setA and setB 
		var strPattern = '';
		var arrPattern = this.getStopSequence().map(stop => {
			if (setHome.has(stop)) return Trip.chars.homeChar;
			if (setSchool.has(stop)) return Trip.chars.schoolChar;
			else return Trip.chars.anyChar;
		});
		return arrPattern.join(joinChar)
	}
	*/
	/* modified 10-06-2021 */
	getPatternHomeSchool(homeStation,schoolStation, joinChar = '-'){
		var homeStops = (homeStation) ? homeStation.getSubStops() : [];
		var schoolStops = (schoolStation) ? schoolStation.getSubStops() : [];
		var homeStopIds = homeStops.map(homeStop => homeStop.getId());
		var schoolStopIds = schoolStops.map(schoolStop => schoolStop.getId());
		var setHomeIds = new Set(homeStopIds);
		var setSchoolIds = new Set(schoolStopIds);  // TODO: check common elements between setA and setB 
		var strPattern = '';
		var arrPattern = this.getStopSequence().map(stop => {
			var id = stop.getId();
			if (setHomeIds.has(id)) return Trip.chars.homeChar;
			if (setSchoolIds.has(id)) return Trip.chars.schoolChar;
			else return Trip.chars.anyChar;
		});
		return arrPattern.join(joinChar)
	}

}
Trip.chars = { homeChar : 'H', schoolChar : 'S', anyChar : '*'}

export class Time extends ScheduleModelInterface{
	constructor(time){
		super();
		var  _stopId = (time) ? time.stopId : '',  // do not clone the stop 
			 _dep = (time) ? time.dep : '',
			 _hidden = false,
			 _pickupType = (time) ? time.pickupType : 0 ,
			 _dropoffType = (time) ? time.dropoffType : 0
		;

		Object.defineProperty(this,'clazz',{
			get : function(){
				return Time;
			},
			enumerable : false
		});
	
		
		
		Object.defineProperty(this,'stopId',{
			set : function(v){
				_stopId = v;
			},
			get : function(){
				return _stopId;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'dep',{
			set : function(v){
				if (v.split(':').length ===3 ){
					_dep = v.split(':').slice(0,2).join(':');
				} else _dep = v;
			},
			get : function(){
				return _dep;
			},
			enumerable : true
		});

		Object.defineProperty(this,'dropoffType',{
			set : function(d){ 
				_dropoffType = d;
			},
			get : function(){ return _dropoffType }
		});

		Object.defineProperty(this,'pickupType',{
			set : function(p){ 
				_pickupType = p;
			},			
			get : function(){ return _pickupType }
		});



		
		Object.defineProperty(this,'hidden',{ // ## COMMENT actual property (contrary to "hide" which is an action/method )
			set : function(b){ _hidden = b },
			get : function(){ return _hidden }
		})

		
	}
	// property accessors
	// ------------------
	getStop(){
		return this.stopId;
	}
	getDeparture(){ return this.dep }

	getDropoffType(){ return this.dropoffType }

	getPickupType(){ return this.pickupType }

	// log 
	// ---
	log(){
		var ret = {};
		ret.stop = `(${this.stopId.getId()}) ${this.stopId.getName()}`;
		ret.dep = this.getDeparture();
		//ret.stop = this.stopId.getId();
		// ret.stop = this.stopId.log.call(this.stopId);
		return ret;
	}

	// state modifiers
	// ---------------
	hide(){
		this.hidden = true;
	}
	show(){
		this.hidden = false; 
	}

	// state accessors
	// ---------------
	isHidden(){ return this.hidden }

	// tests
	// -----
	hasDropoffType(type){
		return (this.getDropoffType() === type);
	}

	hasPickupType(type){
		return (this.getPickupType() === type);
	}
}
